import { REACT_APP_API_KEY, REACT_APP_API_URL } from "src/config/Url";

export const headers = {
  "x-api-key": REACT_APP_API_KEY,
};
